export default "__VITE_ASSET__CwP2MWGG__"